var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0C24.8366 0 32.0001 7.1635 32.0001 16C32.0001 24.8365 24.8366 32 16.0001 32C16.0001 31.3044 13.9132 16 13.9132 16L16.0001 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.1635 32 0 24.8365 0 16C0 7.1635 7.1635 0 16 0",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4378 12.931L18.1251 14.7401L15.999 14.0506L17.3139 15.8581L16.0013 17.6672L18.1265 16.9752L19.4414 18.7827L19.44 16.5476L21.5653 15.8556L19.4393 15.1662L19.4378 12.931Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3272 20.5218C14.8299 20.5218 12.8054 18.4973 12.8054 16C12.8054 13.5028 14.8299 11.4783 17.3272 11.4783C18.1058 11.4783 18.8385 11.6751 19.4781 12.0218C18.4746 11.0404 17.1023 10.4348 15.588 10.4348C12.5144 10.4348 10.0228 12.9264 10.0228 15.9999C10.0228 19.0735 12.5145 21.5651 15.588 21.5651C17.1024 21.5651 18.4747 20.9594 19.4781 19.9781C18.8385 20.3249 18.1058 20.5218 17.3272 20.5218Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/DZ.75380bf5.svg";
export { ForwardRef as ReactComponent };